import { __decorate } from "tslib";
import { injectable } from "inversify";
let UserLocaleResolver = class UserLocaleResolver {
};
UserLocaleResolver = __decorate([
    injectable()
], UserLocaleResolver);
export { UserLocaleResolver };
//# sourceMappingURL=UserLocaleResolver.js.map